<acabim-datatable [dataSources]="[this]" [dataKey]="'seatId'" [hasDetailView]="false" [hasEditButton]="true" (updateDetail)="onDataUpdated($event)"></acabim-datatable>
<div class="pt-3">
    <acabim-admin-add-organisation-seat (trialRequestCreated)="rowData.push($event)"></acabim-admin-add-organisation-seat>
</div>

<p-toast position="top-right" key="subscription-seats"></p-toast>
